// 常规 巡检记录
import React, { useEffect, useState, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  DeleteOutlined,
  CaretRightOutlined,
  PictureOutlined,
  SyncOutlined,
  MenuOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  SearchOutlined
} from '@ant-design/icons';
import { Radio, Card, DatePicker, theme, Table, Tag, Dropdown, Popconfirm, App, Input, Space, Button, Select } from 'antd';
import { getRoutineInspection, goBreakApi, delRecordApi } from '@/server/risk'
import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';
import dayjs from 'dayjs'

function Record (props) {
  const location = useLocation();//接受传值数据
  const {
    token: { colorTextPlaceholder, },
  } = theme.useToken(); //获取主题颜色
  const { message } = App.useApp();
  const { RangePicker } = DatePicker;
  const Stateparams = useLocation();
  const params = Stateparams.state;
  const navigate = useNavigate()

  const [AirportPermissionsArrName, setAirportPermissionsArrName] = useState([])//权限列表
  /**
   * data
   * */
  const [spinningLoading, _spinningLoading] = useState(false);
  const searchInput = useRef(null);//搜索框数据
  const [total, _total] = useState(0);
  const [List, _List] = useState();
  const [searchList, setSearchList] = useState({
    order: '',
    status: '',
    urlType: 1,
    type: 1,//1:记录   2统计
    title: '',//航线名称
    executetype: undefined,//巡检记录类型
    s_start_time: undefined,//开始-开始时间
    s_end_time: undefined,//开始-结束时间
    e_start_time: undefined,//结束-开始时间
    e_end_time: undefined,//结束-结束时间
    dock_id: undefined,//机场id
    current: 1,
    pageSize: 10,
  });
  const [dockNameType, setDockNameType] = useState([]);//机场字典
  const [dockNameTypeVal, setDockNameTypeVal] = useState([])//机场ID

  const [typeDictionary, setTypeDictionary] = useState([])//类型字典

  const getList = async (sift_data) => {
    _List([])
    _spinningLoading(true)
    let res = await getRoutineInspection({
      access_token: localStorage.getItem('dock_token') || '',
      type: sift_data.urlType,
      types: sift_data.type,
      title: sift_data.title,
      order: sift_data.order,
      dock_id: sift_data.type === 1 ? sift_data.dock_id : undefined,
      executetype: sift_data.type === 1 ? sift_data.executetype : undefined,
      status: sift_data.status,
      s_start_time: sift_data.s_start_time,
      s_end_time: sift_data.s_end_time,
      e_start_time: sift_data.e_start_time,
      e_end_time: sift_data.e_end_time,
      page: sift_data.current,
      perpage: sift_data.pageSize,
    });
    _spinningLoading(false)
    if (res.ret === 200) {
      let arr = []
      if (res.data.items && res.data.items.length > 0) {
        res.data?.items.forEach((item, index) => {
          let ch = []
          let obj = {}
          if (item.c_list && item.c_list.length > 0) {
            item?.c_list.forEach((ele, idx) => {
              let list = {
                ...ele,
                numKey: `${index}_${idx}`
              }
              ch.push(list)
            })
            obj = {
              ...item,
              c_list: ch,
              numKey: index,
            }
            obj.dock_id = Number(obj.dock_id);
            arr.push(obj)
          } else {
            let obj2 = {
              ...item,
              numKey: index,
            }
            obj2.dock_id = Number(obj2.dock_id);
            arr.push(obj2)
          }
        });
      }
      _List(arr || []);
      // _List(res.data.items || []);
      _total(res.data.total || 0)

      // 机场字典
      let dockDictionary = res.data.sjzd?.dock.map((res) => {
        return {
          label: res.dock_name,
          value: Number(res.id)
        }
      })
      let dockDictionaryVal = res.data.sjzd?.dock.map((res) => {
        return Number(res.id)
      })


      setDockNameType([...dockDictionary]);
      setDockNameTypeVal([...dockDictionaryVal]);

      setTypeDictionary([...res.data.sjzd?.executetype])
    }
  };

  const delRecordList = async (id) => {
    let res = await delRecordApi({ access_token: localStorage.getItem('dock_token') || '', id: id })
    if (res.ret !== 200) {
      message.warning(res.msg || '服务器开了小差，请重试');
      return;
    }
    let sea = searchList
    if (total > 10 && total % 2 === 1 && searchList.page > 1) {
      sea.page = sea.page - 1
      setSearch({ ...sea })
    }
    message.success('删除成功');
    getList(sea);
  }

  // 分页、排序、筛选变化时触发
  const handleTableChange = (newPagination, filters, sorter) => {
    let searchBefore = { ...searchList };
    // 分页
    searchBefore.current = newPagination.current;
    searchBefore.pageSize = newPagination.pageSize;
    setSearchList({ ...searchBefore })
    getList(searchBefore) //加载列表
  };

  //图片查看页
  const PictureViewPage = (item) => {
    let transfer = {
      title: item.routes_name,
      start_time: item.start_time,
      end_time: item.end_time,
      companyId: item.CompanyID,
      statid: item.statId || item.id,
      insIds: item.InsIDs,
      search: searchList
    }
    navigate('/routine_record_info', { state: transfer })
  }

  const columns = [
    {
      title: '类型',
      dataIndex: 'executetype',
      render: (text, record) => {
        // text === 1 ? `常规` : text === 2 ? `临时` : text === 3 ? `指令` : `暂无类型`
        switch (text) {
          case 1:
            return (<div>常规</div>)
          case 2:
            return (<div>临时</div>)
          case 3:
            return (<div>指令</div>)
          default:
            return (<div>暂无类型</div>)
        }
      },
      // filters: typeDictionary,
      // filterMultiple: false,
    },
    {
      title: '航线名称',
      dataIndex: 'routes_name',
      render: (text, record) => {
        return (
          text && JSON.stringify(text) !== ''
            ? <div>{text}</div>
            : <div style={{ color: colorTextPlaceholder }}>-</div>
        )
      },
      // ...SearchProps('航线名称'),
    },
    {
      title: '机场',
      dataIndex: 'dock_id',
      render: (text, record) => {
        return (
          text && dockNameTypeVal.indexOf(text) >= 0
            ? <div>{dockNameType[dockNameTypeVal.indexOf(text)].label}</div>
            : <div style={{ color: colorTextPlaceholder }}>-</div>
        )
      },
      // filters: dockNameType,
      // filterMultiple: false,
    },
    {
      title: '总里程(km)',
      dataIndex: 'routes_len',
      render: (text, record) => {
        return (
          text
            ? <div>{text}</div>
            : <div style={{ color: colorTextPlaceholder }}>-</div>
        )
      },
    },
    {
      title: '巡检开始时间',
      dataIndex: 'start_time',
      render: (text, item, index) => {
        return (
          <div>
            {
              item.start_time ?
                <div>
                  <span className='fSize14 opacity0_85 margR8'>{text.split(' ')[0]}</span>
                  <span className='fSize14 opacity0_45'>{text.split(' ')[1]}</span>
                </div>
                : <div style={{ color: colorTextPlaceholder }}>-</div>
            }
          </div>
        );
      },
    },
    {
      title: '巡检结束时间',
      dataIndex: 'end_time',
      render: (text, item, index) => {
        return (
          <div>
            {
              text
                ?
                <div>
                  <span className='fSize14 opacity0_85 margR8'>{text.split(' ')[0]}</span>
                  <span className='fSize14 opacity0_45'>{text.split(' ')[1]}</span>
                </div>
                : <div style={{ color: colorTextPlaceholder }}>-</div>
            }
          </div>
        );
      },
    },
    {
      title: '图像',
      dataIndex: 'pic_count',
      render: (text, record) => {
        return (
          text
            ?
            <div className='flex pointer'
              onClick={() => {
                PictureViewPage(record)
              }}
            >
              <span className='pdR8' style={{ color: '#177DDC' }} >{text}</span>
              <PictureOutlined style={{ color: '#177DDC' }} />
            </div>
            : <div style={{ color: colorTextPlaceholder }}>-</div>
        )
      },
    },
    {
      title: '状态',
      dataIndex: 'ins_status',
      render: (text, record) => {
        return (
          <div className='flex'>
            <div>
              <Tag style={{ display: text === 2 ? `block` : `none` }}
                icon={<SyncOutlined spin />} color="processing">
                执行中
              </Tag>
            </div>
            <div>
              <Tag style={{ display: text === 1 || text === 3 ? `block` : `none` }}
                icon={<CheckCircleOutlined />} color="success">
                完成
              </Tag>
            </div>
            <div>
              <Tag style={{ display: text === 5 ? `block` : `none` }}
                icon={<CloseCircleOutlined />} color="error">
                失败
              </Tag>
            </div>
          </div>
        )
      },
    },
    {
      title: '说明',
      dataIndex: 'remark',
      render: (text, item, index) => {
        return (
          <div>
            {
              text
                ? (
                  <div className='flex jcl align_center'>{text}</div>
                )
                : (
                  <div style={{ color: colorTextPlaceholder }}>-</div>
                )
            }
          </div >
        )
      },
    },
    {
      title: '操作',
      dataIndex: 'operate',
      type: 'operate',
      render: (text, record) => {
        return (
          <Dropdown
            trigger={['click']}
            menu={dropDownOption(record)}
            placement="bottom"
          >
            <MenuOutlined className='pointer col_primary' />
          </Dropdown>
        );
      },
    },
  ];

  //表格操作列表
  const dropDownOption = (item) => {
    let typeArr = [
      {
        key: '1',
        permissions: item.break_state && item.ins_status === 5,
        label: (
          <Popconfirm
            title="断点续飞"
            description="确定要使用断点续飞功能？"
            onConfirm={async () => {
              let res = await goBreakApi({
                access_token: localStorage.getItem('dock_token') || '',
                insid: item.InsIDs
              })
              if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了') }
              message.success(res.msg || '续飞成功')
              setTimeout(() => {
                getList(searchList)
              }, 1000);
            }}
            okText="确定"
            cancelText="取消"
          >
            <CaretRightOutlined className='marR10' /> 断点续飞
          </Popconfirm>
        ),
      },
      {
        key: '2',
        permissions: `InsImageList_Del_${searchList.urlType}`,
        label: (
          <div
            onClick={() => { delRecordList(item.id) }}
          >
            <DeleteOutlined className='marR10' /> 删除
          </div>
        ),
      },
    ]
    // 判断权限是否存在
    let arr = []
    typeArr.forEach((item) => {
      if (item.permissions === true || AirportPermissionsArrName.indexOf(item.permissions) > -1 || item.permissions === "") {
        arr.push(item)
      }
    })
    return { items: arr }
  }

  useEffect(() => {//监听路由  获取相应的urlType
    let sea = searchList
    sea.title = ''//航线名称
    sea.dock_id = undefined//机场
    sea.executetype = undefined//类型
    sea.executetype = undefined//巡检记录类型
    sea.s_start_time = undefined//开始-开始时间
    sea.s_end_time = undefined//开始-结束时间
    sea.e_start_time = undefined//结束-开始时间
    sea.e_end_time = undefined//结束-结束时间

    switch (location.pathname) {
      case '/routine_record_conduit'://管道
        sea.urlType = 1
        sea.type = 1
        break;
      case '/routine_record_powerGrid'://电网
        sea.urlType = 7
        sea.type = 1
        break;
      default:
        break;
    }
    setAirportPermissionsArrName([...JSON.parse(localStorage.getItem('dock_AirportPermissionsArrName'))])
    if (params) {
      setSearchList({ ...params.search });
      getList({ ...params.search });
    } else {
      setSearchList({ ...sea });
      getList(sea);
    }

    //eslint-disable-next-line
  }, [params, location.pathname])

  return (
    <div className="hei100 borbox tablebackcol mar24" style={{ overflowY: 'auto' }}>
      <Card style={{ border: 0 }}>
        <div className='flex-auto backcol'>

          <>{/* 头部搜索 */}
            <div className='marB24 flex jcsb'>

              <>{/* 左侧 记录/统计 */}
                <Radio.Group
                  value={searchList.type}
                  optionType="button"
                  onChange={(e) => {
                    let sea = searchList
                    sea.type = e.target.value
                    sea.current = 1
                    setSearchList({ ...sea })
                    getList(sea)
                  }}
                  options={[
                    {
                      label: '记录',
                      value: 1,
                    },
                    {
                      label: '统计',
                      value: 2,
                    },
                  ]}
                />
              </>


              <>{/* 右侧 */}

                <Space>
                  <>
                    {
                      searchList.type === 1 &&
                      <>
                        <Select // 类型
                          allowClear
                          className='wid100'
                          placeholder='类型'
                          options={typeDictionary}
                          value={searchList.executetype}
                          onChange={(e) => {
                            let sea = searchList
                            sea.executetype = e
                            sea.current = 1
                            setSearchList({ ...sea })
                            getList(sea)
                          }}
                        />

                        <Select // 机场
                          allowClear
                          className='w156'
                          placeholder='机场'
                          options={dockNameType}
                          value={searchList.dock_id}
                          onChange={(e) => {
                            let sea = searchList
                            sea.dock_id = e
                            sea.current = 1
                            setSearchList({ ...sea })
                            getList(sea)
                          }}
                        />
                      </>
                    }
                  </>

                  <>{/* 航线名称 */}
                    <Input
                      allowClear
                      placeholder='航线名称'
                      id='Input_LineNameInput'
                      value={searchList.title}
                      onChange={(e) => {
                        let sea = searchList
                        sea.title = e.target.value
                        setSearchList({ ...sea })
                      }}
                      onPressEnter={() => { document.getElementById('Input_LineNameInput').blur() }}
                      onBlur={(e) => {
                        let sea = searchList
                        sea.title = e.target.value
                        sea.current = 1
                        setSearchList({ ...sea })
                        getList(sea)
                      }}
                    />
                  </>



                  <RangePicker //巡检开始起止
                    locale={locale}
                    showHour
                    clearFilters
                    value={searchList.s_start_time ? [dayjs(searchList.s_start_time, 'YYYY-MM-DD'), dayjs(searchList.s_end_time, 'YYYY-MM-DD')] : null}
                    format="YYYY-MM-DD"
                    placeholder={['巡检开始起', '巡检开始止']}
                    onChange={(e) => {
                      let sea = searchList
                      if (e) {
                        sea.s_start_time = dayjs(e[0]).format('YYYY-MM-DD')
                        sea.s_end_time = dayjs(e[1]).format('YYYY-MM-DD')
                      } else {
                        sea.s_start_time = ''
                        sea.s_end_time = ''
                      }
                      sea.current = 1
                      setSearchList({ ...sea })
                      getList(sea)
                    }}
                  />

                  <RangePicker //巡检结束起止
                    locale={locale}
                    showHour
                    clearFilters
                    value={searchList.e_start_time ? [dayjs(searchList.e_start_time, 'YYYY-MM-DD'), dayjs(searchList.e_end_time, 'YYYY-MM-DD')] : null}
                    format="YYYY-MM-DD"
                    placeholder={['巡检结束起', '巡检结束止']}
                    onChange={(e) => {
                      let sea = searchList
                      if (e) {
                        sea.e_start_time = dayjs(e[0]).format('YYYY-MM-DD')
                        sea.e_end_time = dayjs(e[1]).format('YYYY-MM-DD')
                      } else {
                        sea.e_start_time = ''
                        sea.e_end_time = ''
                      }
                      sea.current = 1
                      setSearchList({ ...sea })
                      getList(sea)
                    }}
                  />

                </Space>
              </>

            </div>
          </>

          <>{/* 表格 */}
            {
              searchList.type === 1 &&//记录
              (
                <Table
                  loading={spinningLoading}
                  columns={columns.filter(item => AirportPermissionsArrName?.indexOf(item.type) >= 0 || !item.type || item.type === 'operate')}
                  rowKey='numKey'
                  dataSource={List}
                  // expandRowByClick={true}
                  // childrenColumnName='c_list'
                  pagination={
                    {
                      total: total,
                      current: searchList.current,
                      pageSize: searchList.pageSize,
                      showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                      showQuickJumper: true,
                      showSizeChanger: true,
                    }
                  }
                  onChange={handleTableChange}
                />
              )
            }
            {
              searchList.type === 2 &&//统计
              (
                <Table
                  loading={spinningLoading}
                  columns={columns.filter(item => ['executetype', 'pic_count', 'dock_id', 'ins_status', 'remark', 'operate'].indexOf(item.dataIndex) <= -1)}
                  rowKey='numKey'
                  dataSource={List}
                  // expandRowByClick={true}
                  // childrenColumnName='c_list'
                  pagination={false}
                  onChange={handleTableChange}
                />
              )
            }
          </>




        </div>
      </Card>
    </div>
  )
}
export default Record